// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FV_r","type":"styles_type__2VCvj","choices":"styles_choices__2eWay"};